(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-marketing/assets/javascripts/components/marketing-image.js') >= 0) return;  svs.modules.push('/modules/grassroots-marketing/assets/javascripts/components/marketing-image.js');

'use strict';

const {
  useState
} = React;
const imgSrc = size => "".concat(svs.core.config.data.svsconfig.cdn, "/images/grassroots-marketing/banners/grasrotenbanners_").concat(size, ".gif?ver=7");
const MarketingImage = _ref => {
  let {
    size,
    activeImage,
    onClick
  } = _ref;
  const [hover, setHover] = useState(false);
  return React.createElement("div", {
    className: "marketing-image-container",
    onClick: () => onClick(size),
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, React.createElement("h3", {
    className: "h3 marketing-image-header"
  }, size), React.createElement("img", {
    className: [hover ? 'marketing-image-hover' : '', size === activeImage ? 'marketing-image-active' : ''].filter(p => p).join(' '),
    src: imgSrc(size)
  }));
};
svs.grassroots.components.MarketingImage = MarketingImage;

 })(window);